<template>
  <div class="card shadow-sm mb-4">
    <div class="card-header bg-accent">
      <h4 class="mb-0 text-white fs-1vw">تعیین سطح شایستگی‌های مورد انتظار</h4>
    </div>
    <div class="card-body">
      <div class="row mb-3 justify-content-center">
        <div class="col-md-3 mb-3" :class="!selectedSubCompetency ? 'col-md-6' : ''">
          <label class="form-label fw-bold">شایستگی</label>
          <VSelect
              v-model="selectedCompetency"
              :options="competencies"
              label="competency"
              placeholder="شایستگی را انتخاب کنید"
              dir="rtl"
              @update:modelValue="toNull(['selectedSubCompetency', 'selectedDetail']);">
            <template v-slot:no-options>
              شایستگی یافت نشد!
            </template>
          </VSelect>
        </div>

        <div class="col-md-3 mb-3" :class="!selectedSubCompetency ? 'col-md-6' : ''" v-if="selectedCompetency">
          <label class="form-label fw-bold">زیرمجموعه</label>
          <VSelect
              v-model="selectedSubCompetency"
              :options="selectedCompetency.subCompetencies"
              label="title"
              placeholder="زیرمجموعه را انتخاب کنید"
              dir="rtl"
              @update:modelValue="handleSubCompetencyChange">
            <template v-slot:no-options>
              زیرمجموعه‌ای یافت نشد!
            </template>
          </VSelect>
        </div>

        <div class="col-md-3" v-if="selectedSubCompetency &&
         selectedSubCompetency.details &&
          selectedSubCompetency.details.length > 0 &&
          selectedSubCompetency.details[0].description">
          <label class="form-label fw-bold">توضیحات</label>
          <VSelect
              v-model="selectedDetail"
              :options="selectedSubCompetency.details"
              label="description"
              placeholder="توضیحات را انتخاب کنید"
              dir="rtl">
            <template v-slot:no-options>
              توضیحاتی یافت نشد!
            </template>
          </VSelect>
        </div>

        <div class="col-md-3" v-if="selectedDetail">
          <label class="form-label fw-bold">سطح شایستگی مورد نیاز</label>
          <VSelect
              v-model="selectedDetail.requiredCompetencyLevel"
              :options="levels"
              placeholder="سطح شایستگی را انتخاب کنید"
              dir="rtl"
              @update:modelValue="setLevel">
            <template v-slot:no-options>
              سطحی یافت نشد!
            </template>
          </VSelect>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {useToast} from "vue-toastification";
import VSelect from 'vue-select';

export default {
  components: {
    VSelect
  },
  props: {
    competencies: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      selectedCompetency: null,
      selectedSubCompetency: null,
      selectedDetail: null,
      levels: ['خیلی زیاد', 'زیاد', 'متوسط', 'کم', 'خیلی کم'],
    }
  },
  methods: {
    toNull(data) {
      data.forEach(item => this[item] = null);
    },
    handleSubCompetencyChange() {
      this.toNull(['selectedDetail']);

      if (this.selectedSubCompetency && this.selectedSubCompetency.details && this.selectedSubCompetency.details.length > 0) {
        this.selectedDetail = this.selectedSubCompetency.details[0];
      }
    },
    setLevel() {
      if (this.selectedDetail) {
        const toast = useToast();
        toast.success("سطح شایستگی مورد نیاز ثبت شد.");
        // Server update
      }
    }
  }
}
</script>
